import * as React from 'react';

import { InputProps } from 'shared/newEntities/components/Input';
import {
  CircledExclamationMarkIcon,
  CircledQuestionIcon,
  CloseEyeIcon,
  EyeIcon
} from 'shared/newComponents/icons';
import { IconSize } from 'shared/entities/components/Icon';
import { ComponentType } from 'shared/entities/components/Component';
import Reference from 'shared/newComponents/Reference';

import './TrailingExtras.modules.scss';

type Props = Pick<InputProps, 'error' | 'currency' | 'reference'> & {
  isPasswordField: boolean;
  innerType: React.HTMLInputTypeAttribute;
  showErrorIconInField: boolean;
  isError: boolean;
  onTogglePasswordVisibility: () => void;
};

const TrailingExtras: React.FC<Props> = ({
  isPasswordField,
  innerType,
  showErrorIconInField,
  isError,
  error,
  currency,
  reference,
  onTogglePasswordVisibility
}) => {
  const errorIcon = (
    <CircledExclamationMarkIcon
      iconSize={IconSize.S}
      styleName="trailing-extras__icon trailing-extras__icon_error"
    />
  );

  switch (true) {
    case isPasswordField:
      return (
        <>
          {innerType === 'password' ? (
            <EyeIcon
              styleName="trailing-extras__icon trailing-extras__icon_eye"
              iconSize={IconSize.S}
              action={{
                type: ComponentType.svg,
                onClick: onTogglePasswordVisibility
              }}
            />
          ) : (
            <CloseEyeIcon
              styleName="trailing-extras__icon trailing-extras__icon_eye"
              iconSize={IconSize.S}
              action={{
                type: ComponentType.svg,
                onClick: onTogglePasswordVisibility
              }}
            />
          )}
          {showErrorIconInField && errorIcon}
        </>
      );
    case showErrorIconInField:
      return <Reference title={error} trigger={errorIcon} />;
    case !isError:
      return (
        <>
          {currency}
          {reference && (
            <Reference
              {...reference}
              trigger={
                <div styleName="trailing-extras__icon trailing-extras__icon_reference">
                  <CircledQuestionIcon iconSize={IconSize.S} />
                </div>
              }
            />
          )}
        </>
      );
    default:
      return null;
  }
};

export default React.memo(TrailingExtras);
